// 推广页相关状态
export default {
  namespaced: true,

  state() {
    return {
      /* ---------------------- 免上线免检 ---------------------- */
      vehicleInspection: {
        // 取送车地址
        addressInfo: undefined,
        // 店铺信息
        storeInfo: undefined,
        // 渠道商id
        channelCompanyId: '',

        // 定位信息
        /* interface Position {
            adcode: string;
            citycode: string;
            address: string;
            center: [number, number];
          }*/
        position: undefined,
      }
    }
  },

  mutations: {
    // 设置取送车地址
    setAddress(state, address) {
      state.vehicleInspection.addressInfo = address
      // 更新地址时，清除选中的门店
      state.vehicleInspection.storeInfo = undefined
    },

    clearAddress(state) {
      state.vehicleInspection.addressInfo = undefined
    },

    // 设置门店
    setStore(state, store) {
      state.vehicleInspection.storeInfo = store
    },

    clearStore(state) {
      state.vehicleInspection.storeInfo = undefined
    },

    // 设置渠道商id
    setChannelCompanyId(state, id) {
      state.vehicleInspection.channelCompanyId = id
    },

    clearChannelCompanyId(state) {
      state.vehicleInspection.channelCompanyId = undefined
    },

    // 设置位置信息
    setPosition(state, info) {
      state.vehicleInspection.position = info
    },

    clearPosition(state) {
      state.vehicleInspection.position = undefined
    }
  },
}